function is_valid_rgb(rgbArr) {
  /*
    @rgbArr: array with rgb value
    returns true if the given array is a valid rgb array (number & 0-255)
  */
  let flag = true; // not rgb
  if (rgbArr.constructor === Array && rgbArr.length == 3) {
    for (const c of rgbArr) {
      if (c.constructor === Number && c >= 0 && c <= 255) {
        flag = false;
      }
    }
  } else if (rgbArr.constructor === Array && rgbArr.length == 4) {
    for (const i in rgbArr) {
      let c = rgbArr[i];
      if (i < 3 && c.constructor === Number && c >= 0 && c <= 255) {
        flag = false;
      } else if (i == 3 && c.constructor === Number && c >= 0 && c <= 1) {
        flag = false;
      }
    }
  }
  return !flag;
}

function decode_rgb(rgb) {
  /*
    @rgb: any color value represented as hex code, rgb, rgba, and valid html color names
    returns rgb value array if the given array is a valid rgb array (number & 0-255), null otherwise.
  */
  let result = [];
  let regex = {
    hex6: /^#([A-Fa-f0-9]{6})$/g,
    hex3: /^#([A-Fa-f0-9]{3})$/g,
    rgb: /^(rgb\s*\(\s*[0-9]{1,3}\s*\,\s*[0-9]{1,3}\s*\,\s*[0-9]{1,3}\s*\))$/g,
    rgba: /^(rgba\s*\(\s*[0-9]{1,3}\s*\,\s*[0-9]{1,3}\s*\,\s*[0-9]{1,3}\s*,\s*[0-9]*(\.[0-9]*)?\s*\))$/g
  }
  if (is_valid_rgb(rgb)) {
    return rgb;
  } else if (rgb.constructor.name === "String" && rgb.match(regex.hex6)) { // #000000;
    let hex = rgb.match(regex.hex6)[0];
    let rgb2 = hex.replace("#", "");
    result[0] = parseInt(rgb2.substring(0, 2), 16);
    result[1] = parseInt(rgb2.substring(2, 4), 16);
    result[2] = parseInt(rgb2.substring(4, 6), 16);
  } else if (rgb.constructor.name === "String" && rgb.match(regex.hex3)) { // #000;
    let hex = rgb.match(regex.hex3)[0];
    let rgb2 = hex.replace("#", "");
    result[0] = parseInt(rgb2.substring(0, 1), 16) * 17;
    result[1] = parseInt(rgb2.substring(1, 2), 16) * 17;
    result[2] = parseInt(rgb2.substring(2, 3), 16) * 17;
  } else if (rgb.constructor.name === "String" && rgb.match(regex.rgba)) { // rgba
    let rgba = rgb.match(regex.rgba)[0];
    rgba = rgba.replace(/\s+/g, "").replace("rgba(", "").replace(")", "");
    result = rgba.split(",").map(function (c) {
      return parseInt(c)
    });
  } else if (rgb.constructor.name === "String" && rgb.match(regex.rgb)) { // rgb
    let rgba = rgb.match(regex.rgb)[0];
    rgba = rgba.replace(/\s+/g, "").replace("rgb(", "").replace(")", "")
    result = rgba.split(",").map(function (c) {
      return parseInt(c)
    });
  } else if (rgb.constructor.name === "String" && color_names.hasOwnProperty(rgb.toLowerCase())) {
    result = color_names[rgb];
  }
  if (is_valid_rgb(result)) return result;
  else return null;
}

let color_names = {
  "black": [0, 0, 0],
  "night": [12, 9, 10],
  "gunmetal": [44, 53, 57],
  "midnight": [43, 27, 23],
  "charcoal": [52, 40, 44],
  "dark slate grey": [37, 56, 60],
  "oil": [59, 49, 49],
  "black cat": [65, 56, 57],
  "iridium": [61, 60, 58],
  "black eel": [70, 62, 63],
  "black cow": [76, 70, 70],
  "gray wolf": [80, 74, 75],
  "vampire gray": [86, 80, 81],
  "gray dolphin": [92, 88, 88],
  "carbon gray": [98, 93, 93],
  "ash gray": [102, 99, 98],
  "cloudy gray": [109, 105, 104],
  "smokey gray": [114, 110, 109],
  "gray": [115, 111, 110],
  "granite": [131, 126, 124],
  "battleship gray": [132, 132, 130],
  "gray cloud": [182, 182, 180],
  "gray goose": [209, 208, 206],
  "platinum": [229, 228, 226],
  "metallic silver": [188, 198, 204],
  "blue gray": [152, 175, 199],
  "light slate gray": [109, 123, 141],
  "slate gray": [101, 115, 131],
  "jet gray": [97, 109, 126],
  "mist blue": [100, 109, 126],
  "marble blue": [86, 109, 126],
  "slate blue": [115, 124, 161],
  "steel blue": [72, 99, 160],
  "blue jay": [43, 84, 126],
  "dark slate blue": [43, 56, 86],
  "midnight blue": [21, 27, 84],
  "navy blue": [0, 0, 128],
  "blue whale": [52, 45, 126],
  "lapis blue": [21, 49, 126],
  "denim dark blue": [21, 27, 141],
  "earth blue": [0, 0, 160],
  "cobalt blue": [0, 32, 194],
  "blueberry blue": [0, 65, 194],
  "sapphire blue": [37, 84, 199],
  "blue eyes": [21, 105, 199],
  "royal blue": [43, 96, 222],
  "blue orchid": [31, 69, 252],
  "blue lotus": [105, 96, 236],
  "light slate blue": [115, 106, 255],
  "windows blue": [53, 126, 199],
  "glacial blue ice": [54, 139, 193],
  "silk blue": [72, 138, 199],
  "blue ivy": [48, 144, 199],
  "blue koi": [101, 158, 199],
  "columbia blue": [135, 175, 199],
  "baby blue": [149, 185, 199],
  "light steel blue": [114, 143, 206],
  "ocean blue": [43, 101, 236],
  "blue ribbon": [48, 110, 255],
  "blue dress": [21, 125, 236],
  "dodger blue": [21, 137, 255],
  "cornflower blue": [100, 149, 237],
  "sky blue": [102, 152, 255],
  "butterfly blue": [56, 172, 236],
  "iceberg": [86, 165, 236],
  "crystal blue": [92, 179, 255],
  "deep sky blue": [59, 185, 255],
  "denim blue": [121, 186, 236],
  "light sky blue": [130, 202, 250],
  "day sky blue": [130, 202, 255],
  "jeans blue": [160, 207, 236],
  "blue angel": [183, 206, 236],
  "pastel blue": [180, 207, 236],
  "sea blue": [194, 223, 255],
  "powder blue": [198, 222, 255],
  "coral blue": [175, 220, 236],
  "light blue": [173, 223, 255],
  "robin egg blue": [189, 237, 255],
  "pale blue lily": [207, 236, 236],
  "light cyan": [224, 255, 255],
  "water": [235, 244, 250],
  "aliceblue": [240, 248, 255],
  "azure": [240, 255, 255],
  "light slate": [204, 255, 255],
  "light aquamarine": [147, 255, 232],
  "electric blue": [154, 254, 255],
  "aquamarine": [127, 255, 212],
  "cyan or aqua": [0, 255, 255],
  "tron blue": [125, 253, 254],
  "blue zircon": [87, 254, 255],
  "blue lagoon": [142, 235, 236],
  "celeste": [80, 235, 236],
  "blue diamond": [78, 226, 236],
  "tiffany blue": [129, 216, 208],
  "cyan opaque": [146, 199, 199],
  "blue hosta": [119, 191, 199],
  "northern lights blue": [120, 199, 199],
  "medium turquoise": [72, 204, 205],
  "turquoise": [67, 198, 219],
  "jellyfish": [70, 199, 199],
  "blue green": [123, 204, 181],
  "macaw blue green": [67, 191, 199],
  "light sea green": [62, 169, 159],
  "dark turquoise": [59, 156, 156],
  "sea turtle green": [67, 141, 128],
  "medium aquamarine": [52, 135, 129],
  "greenish blue": [48, 125, 126],
  "grayish turquoise": [94, 125, 126],
  "beetle green": [76, 120, 126],
  "teal": [0, 128, 128],
  "sea green": [78, 137, 117],
  "camouflage green": [120, 134, 107],
  "sage green": [132, 139, 121],
  "hazel green": [97, 124, 88],
  "venom green": [114, 140, 0],
  "fern green": [102, 124, 38],
  "dark forest green": [37, 65, 23],
  "medium sea green": [48, 103, 84],
  "medium forest green": [52, 114, 53],
  "seaweed green": [67, 124, 23],
  "pine green": [56, 124, 68],
  "jungle green": [52, 124, 44],
  "shamrock green": [52, 124, 23],
  "medium spring green": [52, 128, 23],
  "forest green": [78, 146, 88],
  "green onion": [106, 161, 33],
  "spring green": [74, 160, 44],
  "lime green": [65, 163, 23],
  "clover green": [62, 160, 85],
  "green snake": [108, 187, 60],
  "alien green": [108, 196, 23],
  "green apple": [76, 196, 23],
  "yellow green": [82, 208, 23],
  "kelly green": [76, 197, 82],
  "zombie green": [84, 197, 113],
  "frog green": [153, 198, 142],
  "green peas": [137, 195, 92],
  "dollar bill green": [133, 187, 101],
  "dark sea green": [139, 179, 129],
  "iguana green": [156, 176, 113],
  "avocado green": [178, 194, 72],
  "pistachio green": [157, 194, 9],
  "salad green": [161, 201, 53],
  "hummingbird green": [127, 232, 23],
  "nebula green": [89, 232, 23],
  "stoplight go green": [87, 233, 100],
  "algae green": [100, 233, 134],
  "jade green": [94, 251, 110],
  "green": [0, 255, 0],
  "emerald green": [95, 251, 23],
  "lawn green": [135, 247, 23],
  "chartreuse": [138, 251, 23],
  "dragon green": [106, 251, 146],
  "mint green": [152, 255, 152],
  "green thumb": [181, 234, 170],
  "light jade": [195, 253, 184],
  "tea green": [204, 251, 93],
  "green yellow": [177, 251, 23],
  "slime green": [188, 233, 84],
  "goldenrod": [237, 218, 116],
  "harvest gold": [237, 226, 117],
  "sun yellow": [255, 232, 124],
  "yellow": [255, 255, 0],
  "corn yellow": [255, 243, 128],
  "parchment": [255, 255, 194],
  "cream": [255, 255, 204],
  "lemon chiffon": [255, 248, 198],
  "cornsilk": [255, 248, 220],
  "beige": [245, 245, 220],
  "blonde": [251, 246, 217],
  "antiquewhite": [250, 235, 215],
  "champagne": [247, 231, 206],
  "blanchedalmond": [255, 235, 205],
  "vanilla": [243, 229, 171],
  "tan brown": [236, 229, 182],
  "peach": [255, 229, 180],
  "mustard": [255, 219, 88],
  "rubber ducky yellow": [255, 216, 1],
  "bright gold": [253, 208, 23],
  "golden brown": [234, 193, 23],
  "macaroni and cheese": [242, 187, 102],
  "saffron": [251, 185, 23],
  "beer": [251, 177, 23],
  "cantaloupe": [255, 166, 47],
  "bee yellow": [233, 171, 23],
  "brown sugar": [226, 167, 111],
  "burlywood": [222, 184, 135],
  "deep peach": [255, 203, 164],
  "ginger brown": [201, 190, 98],
  "school bus yellow": [232, 163, 23],
  "sandy brown": [238, 154, 77],
  "fall leaf brown": [200, 181, 96],
  "orange gold": [212, 160, 23],
  "sand": [194, 178, 128],
  "cookie brown": [199, 163, 23],
  "caramel": [198, 142, 23],
  "brass": [181, 166, 66],
  "khaki": [173, 169, 110],
  "camel brown": [193, 154, 107],
  "bronze": [205, 127, 50],
  "tiger orange": [200, 129, 65],
  "cinnamon": [197, 137, 23],
  "bullet shell": [175, 155, 96],
  "dark goldenrod": [175, 120, 23],
  "copper": [184, 115, 51],
  "wood": [150, 111, 51],
  "oak brown": [128, 101, 23],
  "moccasin": [130, 120, 57],
  "army brown": [130, 123, 96],
  "sandstone": [120, 109, 95],
  "mocha": [73, 61, 38],
  "taupe": [72, 60, 50],
  "coffee": [111, 78, 55],
  "brown bear": [131, 92, 59],
  "red dirt": [127, 82, 23],
  "sepia": [127, 70, 44],
  "orange salmon": [196, 116, 81],
  "rust": [195, 98, 65],
  "red fox": [195, 88, 23],
  "chocolate": [200, 90, 23],
  "sedona": [204, 102, 0],
  "papaya orange": [229, 103, 23],
  "halloween orange": [230, 108, 44],
  "pumpkin orange": [248, 114, 23],
  "construction cone orange": [248, 116, 49],
  "sunrise orange": [230, 116, 81],
  "mango orange": [255, 128, 64],
  "dark orange": [248, 128, 23],
  "coral": [255, 127, 80],
  "basket ball orange": [248, 129, 88],
  "light salmon": [249, 150, 107],
  "tangerine": [231, 138, 97],
  "dark salmon": [225, 139, 107],
  "light coral": [231, 116, 113],
  "bean red": [247, 93, 89],
  "valentine red": [229, 84, 81],
  "shocking orange": [229, 91, 60],
  "red": [255, 0, 0],
  "scarlet": [255, 36, 0],
  "ruby red": [246, 34, 23],
  "ferrari red": [247, 13, 26],
  "fire engine red": [246, 40, 23],
  "lava red": [228, 34, 23],
  "love red": [228, 27, 23],
  "grapefruit": [220, 56, 31],
  "chestnut red": [195, 74, 44],
  "cherry red": [194, 70, 65],
  "mahogany": [192, 64, 0],
  "chilli pepper": [193, 27, 23],
  "cranberry": [159, 0, 15],
  "red wine": [153, 0, 18],
  "burgundy": [140, 0, 26],
  "chestnut": [149, 69, 53],
  "blood red": [126, 53, 23],
  "sienna": [138, 65, 23],
  "sangria": [126, 56, 23],
  "firebrick": [128, 5, 23],
  "maroon": [129, 5, 65],
  "plum pie": [125, 5, 65],
  "velvet maroon": [126, 53, 77],
  "plum velvet": [125, 5, 82],
  "rosy finch": [127, 78, 82],
  "puce": [127, 90, 88],
  "dull purple": [127, 82, 93],
  "rosy brown": [179, 132, 129],
  "khaki rose": [197, 144, 142],
  "pink bow": [196, 129, 137],
  "lipstick pink": [196, 135, 147],
  "rose": [232, 173, 170],
  "rose gold": [236, 197, 192],
  "desert sand": [237, 201, 175],
  "pig pink": [253, 215, 228],
  "cotton candy": [252, 223, 255],
  "pink bubble gum": [255, 223, 221],
  "misty rose": [251, 187, 185],
  "pink": [250, 175, 190],
  "light pink": [250, 175, 186],
  "flamingo pink": [249, 167, 176],
  "pink rose": [231, 161, 176],
  "pink daisy": [231, 153, 163],
  "cadillac pink": [227, 138, 174],
  "carnation pink": [247, 120, 161],
  "blush red": [229, 110, 148],
  "hot pink": [246, 96, 171],
  "watermelon pink": [252, 108, 133],
  "violet red": [246, 53, 138],
  "deep pink": [245, 40, 135],
  "pink cupcake": [228, 94, 157],
  "pink lemonade": [228, 40, 124],
  "neon pink": [245, 53, 170],
  "magenta": [255, 0, 255],
  "dimorphotheca magenta": [227, 49, 157],
  "bright neon pink": [244, 51, 255],
  "pale violet red": [209, 101, 135],
  "tulip pink": [194, 90, 124],
  "medium violet red": [202, 34, 107],
  "rogue pink": [193, 40, 105],
  "burnt pink": [193, 34, 103],
  "bashful pink": [194, 82, 131],
  "dark carnation pink": [193, 34, 131],
  "plum": [185, 59, 143],
  "viola purple": [126, 88, 126],
  "purple iris": [87, 27, 126],
  "plum purple": [88, 55, 89],
  "indigo": [75, 0, 130],
  "purple monster": [70, 27, 126],
  "purple haze": [78, 56, 126],
  "eggplant": [97, 64, 81],
  "grape": [94, 90, 128],
  "purple jam": [106, 40, 126],
  "dark orchid": [125, 27, 126],
  "purple flower": [167, 74, 199],
  "medium orchid": [176, 72, 181],
  "purple amethyst": [108, 45, 199],
  "dark violet": [132, 45, 206],
  "violet": [141, 56, 201],
  "purple sage bush": [122, 93, 199],
  "lovely purple": [127, 56, 236],
  "purple": [142, 53, 239],
  "aztech purple": [137, 59, 255],
  "medium purple": [132, 103, 215],
  "jasmine purple": [162, 59, 236],
  "purple daffodil": [176, 65, 255],
  "tyrian purple": [196, 90, 236],
  "crocus purple": [145, 114, 236],
  "purple mimosa": [158, 123, 255],
  "heliotrope purple": [212, 98, 255],
  "crimson": [226, 56, 236],
  "purple dragon": [195, 142, 199],
  "lilac": [200, 162, 200],
  "blush pink": [230, 169, 236],
  "mauve": [224, 176, 255],
  "wisteria purple": [198, 174, 199],
  "blossom pink": [249, 183, 255],
  "thistle": [210, 185, 211],
  "periwinkle": [233, 207, 236],
  "lavender pinocchio": [235, 221, 226],
  "lavender blue": [227, 228, 250],
  "pearl": [253, 238, 244],
  "seashell": [255, 245, 238],
  "milk white": [254, 252, 255],
  "white": [255, 255, 255], "aliceblue": [240, 248, 255],
  "aqua": [255, 255],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "cornflowerblue": [100, 149, 237],
  "crimson": [220, 20, 60],
  "cyan": [255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgrey": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "grey": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgrey": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellowgreen": [154, 205, 50]
};

export const color = {
  isValidRgb: is_valid_rgb,
  decodeRgb: decode_rgb,
  colorNames: color_names
}